import React, { useState, useEffect, useCallback } from "react";
import { getData,serverURL } from "../../../Services/Fetchnodeservices";




const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const EyeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const DeleteIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const AttachmentIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
  </svg>
);

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// HELPER FUNCTION TO GET IMAGE URL
// ─────────────────────────────────────────────────────────────────────────────
const getImageUrl = (filename) => {
  if (!filename) return null;
  
  // If it's already a full URL, return as is
  if (filename.startsWith('http://') || filename.startsWith('https://')) {
    return filename;
  }
  
  // Extract just the filename if path is provided
  let cleanFilename = filename;
  if (filename.includes('/')) {
    cleanFilename = filename.split('/').pop();
  }
  
  // Apply the correct path: serverURL + /public/uploadnew/upload/filename
  return `${serverURL}/public/uploadnew/upload/${cleanFilename}`;
};

// ─────────────────────────────────────────────────────────────────────────────
// VIEW TICKET DIALOG COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const ViewTicketDialog = ({ isDark, onClose, ticket, onStatusUpdate }) => {
  const [status, setStatus] = useState(ticket?.ticketstatus || "open");
  const [updating, setUpdating] = useState(false);
  const [imageError, setImageError] = useState(false);

  // const handleStatusChange = async (newStatus) => {
  //   setUpdating(true);
  //   try {
  //     await putData(`supportticket/Tickets/${ticket.id}`, { ticketstatus: newStatus });
  //     setStatus(newStatus);
  //     if (onStatusUpdate) {
  //       onStatusUpdate(ticket.id, newStatus);
  //     }
  //   } catch (error) {
  //     console.error("Error updating status:", error);
  //   } finally {
  //     setUpdating(false);
  //   }
  // };

  const getUserName = () => {
    if (ticket.user_table === "resturant") return `Restaurant #${ticket.user_id}`;
    if (ticket.user_table === "user") return `User #${ticket.user_id}`;
    if (ticket.user_table === "rider") return `Rider #${ticket.user_id}`;
    return `${ticket.user_table || "Unknown"} #${ticket.user_id}`;
  };

  const screenshotUrl = getImageUrl(ticket.screenshot);

  const dialogStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      backdropFilter: "blur(4px)",
    },
    dialog: {
      width: "90%",
      maxWidth: "550px",
      background: isDark ? "#141824" : "#ffffff",
      borderRadius: "20px",
      boxShadow: "0 25px 40px -12px rgba(0,0,0,0.4)",
      overflow: "hidden",
      animation: "fadeIn 0.2s ease-out",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "18px 24px",
      borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
    },
    title: {
      fontSize: "18px",
      fontWeight: 700,
      color: isDark ? "#f1f5f9" : "#0f172a",
      margin: 0,
    },
    closeBtn: {
      background: "none",
      border: "none",
      cursor: "pointer",
      color: isDark ? "#94a3b8" : "#64748b",
      padding: "4px",
      display: "flex",
      borderRadius: "8px",
    },
    body: {
      padding: "24px",
      maxHeight: "60vh",
      overflowY: "auto",
    },
    fieldGroup: {
      marginBottom: "20px",
    },
    label: {
      fontSize: "11px",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      color: isDark ? "#64748b" : "#94a3b8",
      marginBottom: "6px",
    },
    value: {
      fontSize: "14px",
      color: isDark ? "#f1f5f9" : "#1e293b",
      fontWeight: 500,
    },
    description: {
      fontSize: "13px",
      color: isDark ? "#cbd5e1" : "#475569",
      lineHeight: 1.5,
      whiteSpace: "pre-wrap",
    },
    statusSelect: {
      padding: "8px 12px",
      borderRadius: "8px",
      fontSize: "13px",
      background: isDark ? "#0d1117" : "#f8fafc",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      color: isDark ? "#f1f5f9" : "#1e293b",
      cursor: "pointer",
      width: "100%",
      marginTop: "6px",
    },
    screenshot: {
      maxWidth: "100%",
      maxHeight: "250px",
      borderRadius: "12px",
      marginTop: "12px",
      objectFit: "contain",
      background: isDark ? "#0d1117" : "#f1f5f9",
      padding: "8px",
    },
    footer: {
      display: "flex",
      justifyContent: "flex-end",
      padding: "16px 24px",
      borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      background: isDark ? "#0f1520" : "#fafcff",
    },
    closeFooterBtn: {
      padding: "8px 20px",
      background: "#4a6cf7",
      border: "none",
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: 600,
      color: "#fff",
      cursor: "pointer",
    },
  };

  return (
    <div style={dialogStyles.overlay} onClick={onClose}>
      <div style={dialogStyles.dialog} onClick={(e) => e.stopPropagation()}>
        <div style={dialogStyles.header}>
          <h3 style={dialogStyles.title}>Ticket #{ticket.id}</h3>
          <button style={dialogStyles.closeBtn} onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div style={dialogStyles.body}>
          <div style={dialogStyles.fieldGroup}>
            <div style={dialogStyles.label}>Source</div>
            <div style={dialogStyles.value}>{getUserName()}</div>
          </div>
          <div style={dialogStyles.fieldGroup}>
            <div style={dialogStyles.label}>Subject</div>
            <div style={dialogStyles.value}>{ticket.subject}</div>
          </div>
          <div style={dialogStyles.fieldGroup}>
            <div style={dialogStyles.label}>Description</div>
            <div style={dialogStyles.description}>{ticket.description}</div>
          </div>
          <div style={dialogStyles.fieldGroup}>
            <div style={dialogStyles.label}>Status</div>
            <select
              style={dialogStyles.statusSelect}
              value={status}
              // onChange={(e) => handleStatusChange(e.target.value)}
              disabled={updating}
            >
              <option value="open">Open</option>
              <option value="in_progress">In Progress</option>
              <option value="closed">Closed</option>
            </select>
          </div>
          {screenshotUrl && !imageError && (
            <div style={dialogStyles.fieldGroup}>
              <div style={dialogStyles.label}>Screenshot</div>
              <img 
                src={screenshotUrl} 
                alt="Screenshot" 
                style={dialogStyles.screenshot}
                onError={() => setImageError(true)}
              />
            </div>
          )}
          {screenshotUrl && imageError && (
            <div style={dialogStyles.fieldGroup}>
              <div style={dialogStyles.label}>Screenshot</div>
              <div style={{ color: "#ef4444", fontSize: "12px", padding: "8px", background: isDark ? "#1a0a0a" : "#fef2f2", borderRadius: "8px" }}>
                Image not found: {ticket.screenshot}
              </div>
            </div>
          )}
          <div style={dialogStyles.fieldGroup}>
            <div style={dialogStyles.label}>Created At</div>
            <div style={dialogStyles.value}>{new Date(ticket.created_at).toLocaleString()}</div>
          </div>
          {ticket.updated_at && ticket.updated_at !== ticket.created_at && (
            <div style={dialogStyles.fieldGroup}>
              <div style={dialogStyles.label}>Last Updated</div>
              <div style={dialogStyles.value}>{new Date(ticket.updated_at).toLocaleString()}</div>
            </div>
          )}
        </div>
        <div style={dialogStyles.footer}>
          <button style={dialogStyles.closeFooterBtn} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// SUB-COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

const StatusBadge = ({ status, isDark }) => {
  const config = {
    open: { bg: isDark ? "rgba(59,130,246,0.15)" : "rgba(59,130,246,0.1)", color: "#3b82f6", label: "Open" },
    in_progress: { bg: isDark ? "rgba(245,158,11,0.15)" : "rgba(245,158,11,0.1)", color: "#f59e0b", label: "In Progress" },
    closed: { bg: isDark ? "rgba(34,197,94,0.15)" : "rgba(34,197,94,0.1)", color: "#22c55e", label: "Closed" },
  };
  const c = config[status] || config.open;
  return (
    <span style={{
      display: "inline-block", padding: "4px 12px", borderRadius: "20px",
      fontSize: "11px", fontWeight: 600, background: c.bg, color: c.color,
    }}>{c.label}</span>
  );
};

const SourceBadge = ({ userTable, isDark }) => {
  const config = {
    user: { bg: isDark ? "rgba(139,92,246,0.15)" : "rgba(139,92,246,0.1)", color: "#8b5cf6", label: "User" },
    resturant: { bg: isDark ? "rgba(236,72,153,0.15)" : "rgba(236,72,153,0.1)", color: "#ec4899", label: "Restaurant" },
    rider: { bg: isDark ? "rgba(20,184,166,0.15)" : "rgba(20,184,166,0.1)", color: "#14b8a6", label: "Rider" },
  };
  const c = config[userTable] || { bg: isDark ? "rgba(100,116,139,0.15)" : "rgba(100,116,139,0.1)", color: "#64748b", label: "Other" };
  return (
    <span style={{
      display: "inline-block", padding: "2px 8px", borderRadius: "12px",
      fontSize: "10px", fontWeight: 500, background: c.bg, color: c.color,
    }}>{c.label}</span>
  );
};

const StatCard = ({ title, count, color, isDark }) => (
  <div style={{
    background: isDark ? "#141824" : "#ffffff",
    border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
    borderRadius: "12px",
    padding: "16px 20px",
    textAlign: "center",
    minWidth: "80px",
  }}>
    <div style={{ fontSize: "28px", fontWeight: 700, color: color }}>{count}</div>
    <div style={{ fontSize: "11px", fontWeight: 500, color: isDark ? "#64748b" : "#94a3b8", marginTop: "4px" }}>{title}</div>
  </div>
);

const FilterButton = ({ label, isActive, onClick, isDark }) => (
  <button onClick={onClick} style={{
    padding: "6px 14px", borderRadius: "20px", fontSize: "12px", fontWeight: 500,
    background: isActive ? "#3b82f6" : isDark ? "transparent" : "#f1f5f9",
    color: isActive ? "#fff" : isDark ? "#94a3b8" : "#475569",
    border: isActive ? "1px solid #3b82f6" : isDark ? "1px solid #2a3145" : "1px solid #e2e8f0",
    cursor: "pointer",
  }}>{label}</button>
);

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const TicketsTable = ({ isDark = true }) => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [sourceFilter, setSourceFilter] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isViewDialogOpen, setIsViewDialogOpen] = useState(false);
  const itemsPerPage = 10;

  // Fetch tickets from API
  const fetchTickets = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getData("supportticket/Tickets");
      const ticketsData = response.data || [];
      const sortedTickets = [...ticketsData].sort((a, b) => b.id - a.id);
      setTickets(sortedTickets);
    } catch (error) {
      console.error("Error fetching tickets:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTickets();
  }, [fetchTickets]);

  // Stats calculation
  const stats = {
    total: tickets.length,
    open: tickets.filter(t => t.ticketstatus === "open").length,
    inProgress: tickets.filter(t => t.ticketstatus === "in_progress").length,
    closed: tickets.filter(t => t.ticketstatus === "closed").length,
    users: tickets.filter(t => t.user_table === "user").length,
    restaurants: tickets.filter(t => t.user_table === "resturant").length,
    riders: tickets.filter(t => t.user_table === "rider").length,
  };

  // Filter tickets
  const filteredTickets = tickets.filter(ticket => {
    const matchesSearch = 
      ticket.subject?.toLowerCase().includes(search.toLowerCase()) ||
      ticket.description?.toLowerCase().includes(search.toLowerCase()) ||
      ticket.id.toString().includes(search);
    const matchesStatus = statusFilter === "All" || ticket.ticketstatus === statusFilter;
    const matchesSource = sourceFilter === "All" || ticket.user_table === sourceFilter;
    return matchesSearch && matchesStatus && matchesSource;
  });

  // Pagination
  const totalPages = Math.ceil(filteredTickets.length / itemsPerPage);
  const paginatedTickets = filteredTickets.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleViewTicket = (ticket) => {
    setSelectedTicket(ticket);
    setIsViewDialogOpen(true);
  };

  // const handleDeleteTicket = async (id) => {
  //   if (window.confirm("Are you sure you want to delete this ticket?")) {
  //     try {
  //       await deleteData(`supportticket/Tickets/${id}`);
  //       await fetchTickets();
  //     } catch (error) {
  //       console.error("Error deleting ticket:", error);
  //     }
  //   }
  // };

  // const handleStatusUpdate = async (id, newStatus) => {
  //   try {
  //     await putData(`supportticket/Tickets/${id}`, { ticketstatus: newStatus });
  //     setTickets(prev => prev.map(ticket =>
  //       ticket.id === id ? { ...ticket, ticketstatus: newStatus } : ticket
  //     ));
  //   } catch (error) {
  //     console.error("Error updating status:", error);
  //   }
  // };

  const getUserDisplayName = (ticket) => {
    if (ticket.user_table === "resturant") return `Restaurant #${ticket.user_id}`;
    if (ticket.user_table === "user") return `User #${ticket.user_id}`;
    if (ticket.user_table === "rider") return `Rider #${ticket.user_id}`;
    return `${ticket.user_table || "Unknown"} #${ticket.user_id}`;
  };

  const styles = {
    container: { background: "transparent", fontFamily: "'Segoe UI', 'DM Sans', sans-serif", padding: "20px 24px" },
    statsRow: { display: "flex", gap: "12px", marginBottom: "24px", flexWrap: "wrap" },
    statsGroup: { display: "flex", gap: "12px", flexWrap: "wrap" },
    divider: { width: "1px", height: "40px", background: isDark ? "#1e2740" : "#e2e8f0", margin: "0 8px" },
    searchSection: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px", flexWrap: "wrap", gap: "16px" },
    searchWrapper: { position: "relative", flex: 1, maxWidth: "350px" },
    searchIcon: { position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#3b82f6" },
    searchInput: {
      width: "100%", padding: "10px 12px 10px 38px",
      background: isDark ? "#141824" : "#ffffff",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      borderRadius: "10px", fontSize: "13px",
      color: isDark ? "#f1f5f9" : "#1e293b", outline: "none",
    },
    filterGroup: { display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" },
    filterLabel: { fontSize: "12px", fontWeight: 500, color: isDark ? "#64748b" : "#475569" },
    sourceFilters: { display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "20px" },
    sourceBtn: (isActive) => ({
      padding: "6px 16px", borderRadius: "20px", fontSize: "12px", fontWeight: 500,
      background: isActive ? "#3b82f6" : isDark ? "transparent" : "#f1f5f9",
      color: isActive ? "#fff" : isDark ? "#94a3b8" : "#475569",
      border: isActive ? "1px solid #3b82f6" : isDark ? "1px solid #2a3145" : "1px solid #e2e8f0",
      cursor: "pointer",
    }),
    tableWrapper: {
      background: isDark ? "#141824" : "#ffffff",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      borderRadius: "12px", overflow: "auto",
    },
    table: { width: "100%", borderCollapse: "collapse", minWidth: "800px" },
    th: {
      padding: "14px 16px", textAlign: "left", fontSize: "12px", fontWeight: 700,
      color: "#3b82f6", borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      background: isDark ? "#0f1520" : "#f8fafc", whiteSpace: "nowrap",
    },
    td: {
      padding: "14px 16px", fontSize: "13px", color: isDark ? "#e2e8f0" : "#1e293b",
      borderBottom: isDark ? "1px solid #1a2035" : "1px solid #f1f5f9",
    },
    actions: { display: "flex", gap: "8px" },
    actionBtn: { background: "none", border: "none", cursor: "pointer", padding: "4px", color: isDark ? "#64748b" : "#94a3b8", display: "flex", alignItems: "center", justifyContent: "center" },
    attachment: { display: "inline-flex", alignItems: "center", gap: "4px", color: "#f59e0b", fontSize: "11px" },
    sourceCell: { display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" },
    pagination: {
      display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "14px 20px", borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      background: isDark ? "#0f1520" : "#f8fafc",
    },
    pageBtn: (disabled, isActive) => ({
      width: "32px", height: "32px", borderRadius: "6px",
      border: isActive ? "1px solid #3b82f6" : isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      background: isActive ? "#1e3a8a" : isDark ? "#141824" : "#ffffff",
      color: isActive ? "#93c5fd" : disabled ? isDark ? "#2d3a55" : "#cbd5e1" : isDark ? "#94a3b8" : "#64748b",
      cursor: disabled ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center",
    }),
    emptyState: { padding: "60px", textAlign: "center", color: isDark ? "#64748b" : "#94a3b8", fontSize: "14px" },
    loadingState: { padding: "60px", textAlign: "center", color: isDark ? "#64748b" : "#94a3b8", fontSize: "14px" },
    statusSelect: {
      padding: "4px 8px", borderRadius: "6px", fontSize: "11px",
      background: isDark ? "#0f1520" : "#f8fafc",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      color: isDark ? "#e2e8f0" : "#1e293b", cursor: "pointer",
    },
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loadingState}>Loading tickets...</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.96); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>

      {/* Stats Cards Row */}
      <div style={styles.statsRow}>
        <div style={styles.statsGroup}>
          <StatCard title="Total" count={stats.total} color="#3b82f6" isDark={isDark} />
          <StatCard title="Open" count={stats.open} color="#3b82f6" isDark={isDark} />
          <StatCard title="In Progress" count={stats.inProgress} color="#f59e0b" isDark={isDark} />
          <StatCard title="Closed" count={stats.closed} color="#22c55e" isDark={isDark} />
        </div>
        <div style={styles.divider} />
        <div style={styles.statsGroup}>
          <StatCard title="All Tickets" count={stats.total} color="#8b5cf6" isDark={isDark} />
          <StatCard title="Users" count={stats.users} color="#8b5cf6" isDark={isDark} />
          <StatCard title="Restaurants" count={stats.restaurants} color="#ec4899" isDark={isDark} />
          <StatCard title="Riders" count={stats.riders} color="#14b8a6" isDark={isDark} />
        </div>
      </div>

      {/* Search and Status Filters */}
      <div style={styles.searchSection}>
        <div style={styles.searchWrapper}>
          <span style={styles.searchIcon}><SearchIcon /></span>
          <input
            type="text"
            style={styles.searchInput}
            placeholder="Search subject or description..."
            value={search}
            onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
          />
        </div>
        <div style={styles.filterGroup}>
          <span style={styles.filterLabel}>Status:</span>
          <FilterButton label="All" isActive={statusFilter === "All"} onClick={() => { setStatusFilter("All"); setCurrentPage(1); }} isDark={isDark} />
          <FilterButton label="Open" isActive={statusFilter === "open"} onClick={() => { setStatusFilter("open"); setCurrentPage(1); }} isDark={isDark} />
          <FilterButton label="In Progress" isActive={statusFilter === "in_progress"} onClick={() => { setStatusFilter("in_progress"); setCurrentPage(1); }} isDark={isDark} />
          <FilterButton label="Closed" isActive={statusFilter === "closed"} onClick={() => { setStatusFilter("closed"); setCurrentPage(1); }} isDark={isDark} />
        </div>
      </div>

      {/* Source Filters */}
      <div style={styles.sourceFilters}>
        <button style={styles.sourceBtn(sourceFilter === "All")} onClick={() => { setSourceFilter("All"); setCurrentPage(1); }}>All</button>
        <button style={styles.sourceBtn(sourceFilter === "user")} onClick={() => { setSourceFilter("user"); setCurrentPage(1); }}>Users</button>
        <button style={styles.sourceBtn(sourceFilter === "resturant")} onClick={() => { setSourceFilter("resturant"); setCurrentPage(1); }}>Restaurants</button>
        <button style={styles.sourceBtn(sourceFilter === "rider")} onClick={() => { setSourceFilter("rider"); setCurrentPage(1); }}>Riders</button>
      </div>

      {/* Tickets Table */}
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>Source</th>
              <th style={styles.th}>Subject</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Date</th>
              <th style={styles.th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedTickets.map((ticket) => (
              <tr key={ticket.id}>
                <td style={styles.td}>
                  <span style={{ fontWeight: 600, color: "#3b82f6" }}>#{ticket.id}</span>
                </td>
                <td style={styles.td}>
                  <div style={styles.sourceCell}>
                    <span>{getUserDisplayName(ticket)}</span>
                    <SourceBadge userTable={ticket.user_table} isDark={isDark} />
                  </div>
                </td>
                <td style={styles.td}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    {ticket.subject}
                    {ticket.screenshot && (
                      <span style={styles.attachment}>
                        <AttachmentIcon /> Attachment
                      </span>
                    )}
                  </div>
                </td>
                <td style={styles.td}>
                  <select
                    style={styles.statusSelect}
                    value={ticket.ticketstatus}
                    // onChange={(e) => handleStatusUpdate(ticket.id, e.target.value)}
                  >
                    <option value="open">Open</option>
                    <option value="in_progress">In Progress</option>
                    <option value="closed">Closed</option>
                  </select>
                </td>
                <td style={styles.td}>
                  {new Date(ticket.created_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                </td>
                <td style={styles.td}>
                  <div style={styles.actions}>
                    <button style={styles.actionBtn} onClick={() => handleViewTicket(ticket)} title="View Ticket">
                      <EyeIcon />
                    </button>
                    <button style={styles.actionBtn}
                    //  onClick={() => handleDeleteTicket(ticket.id)} 
                    title="Delete">
                      <DeleteIcon />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {paginatedTickets.length === 0 && (
              <tr>
                <td colSpan={6} style={styles.emptyState}>No tickets found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {filteredTickets.length > itemsPerPage && (
        <div style={styles.pagination}>
          <span style={{ fontSize: "12px", color: isDark ? "#64748b" : "#94a3b8" }}>
            Showing {Math.min((currentPage - 1) * itemsPerPage + 1, filteredTickets.length)} to {Math.min(currentPage * itemsPerPage, filteredTickets.length)} of {filteredTickets.length} tickets
          </span>
          <div style={{ display: "flex", gap: "6px" }}>
            <button 
              style={styles.pageBtn(currentPage === 1, false)} 
              onClick={() => setCurrentPage(p => Math.max(1, p - 1))} 
              disabled={currentPage === 1}
            >
              ‹
            </button>
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) pageNum = i + 1;
              else if (currentPage <= 3) pageNum = i + 1;
              else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
              else pageNum = currentPage - 2 + i;
              return pageNum <= totalPages && (
                <button 
                  key={pageNum} 
                  style={styles.pageBtn(false, currentPage === pageNum)} 
                  onClick={() => setCurrentPage(pageNum)}
                >
                  {pageNum}
                </button>
              );
            })}
            <button 
              style={styles.pageBtn(currentPage === totalPages, false)} 
              onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} 
              disabled={currentPage === totalPages}
            >
              ›
            </button>
          </div>
        </div>
      )}

      {/* View Ticket Dialog */}
      {isViewDialogOpen && selectedTicket && (
        <ViewTicketDialog
          isDark={isDark}
          onClose={() => {
            setIsViewDialogOpen(false);
            setSelectedTicket(null);
            fetchTickets();
          }}
          ticket={selectedTicket}
          // onStatusUpdate={handleStatusUpdate}
        />
      )}
    </div>
  );
};

export default TicketsTable;